var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonFormalSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Non-Formal_School",
    "data-name": "Non-Formal School",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#fffaef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    transform: "translate(431 191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9958",
    "data-name": "Path 9958",
    d: "M89.511,28.367V24.609a4.225,4.225,0,0,0-7.818-2.226l-1.186-4.819h3.838a1.409,1.409,0,0,0,1.019-2.382L71.274.436a1.409,1.409,0,0,0-2.038,0L55.147,15.182a1.409,1.409,0,0,0,1.019,2.382H60l-1.186,4.819A4.225,4.225,0,0,0,51,24.609v3.757a9.86,9.86,0,0,0,4.335,8.164l-2.416,9.815a1.409,1.409,0,0,0,1.368,1.746H86.223a1.409,1.409,0,0,0,1.368-1.746l-2.416-9.815A9.86,9.86,0,0,0,89.511,28.367Zm-26.6-13.08a1.409,1.409,0,0,0-1.109-.54H59.461l10.795-11.3,10.795,11.3H78.709a1.409,1.409,0,0,0-1.368,1.746l3.192,12.969a1.4,1.4,0,0,1-.885.314h-4a6.575,6.575,0,1,0-10.782,0h-4a1.4,1.4,0,0,1-.885-.314L63.17,16.493a1.409,1.409,0,0,0-.259-1.206ZM66.5,26.018a3.757,3.757,0,1,1,3.757,3.757A3.761,3.761,0,0,1,66.5,26.018ZM57.929,37.784a9.829,9.829,0,0,0,2.933.445H61.8v7.045H56.085Zm17.962-.964v8.454H64.62V36.82a1.409,1.409,0,0,0-1.409-1.409H60.863a7.053,7.053,0,0,1-7.045-7.045V24.609a1.409,1.409,0,1,1,2.818,0v3.757a4.232,4.232,0,0,0,4.227,4.227H79.648a4.232,4.232,0,0,0,4.227-4.227V24.609a1.409,1.409,0,0,1,2.818,0v3.757a7.053,7.053,0,0,1-7.045,7.045H77.3A1.409,1.409,0,0,0,75.891,36.82Zm8.534,8.454H78.709V38.229h.939a9.828,9.828,0,0,0,2.933-.445Z",
    transform: "translate(0 0)",
    fill: "#c39b4f",
    stroke: "#fffaef",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonFormalSchool);
export default __webpack_public_path__ + "static/media/Non-Formal School.8011bfe8de16c5fd38c7e13e0f7f5b79.svg";
export { ForwardRef as ReactComponent };